<template>
  <div class="mb-16">
    <div class="text-center mt-16 mb-4" dir="auto">
      <!--      <h1 v-scroll-reveal.reset>چرا شیشه اردکان؟</h1>-->
      <h2 v-if="this.$i18n.locale==='en'" class="mx-auto font-weight-bold">
        {{why.section_title }}</h2>
      <h1 v-else  class="mx-auto font-weight-bold">{{ why.section_title }}</h1>
    </div>
    <v-row class="mx-16">
      <v-col  v-for="item in why.topics" cols="12" xl="3" lg="3" md="3" class="text-center d-flex justify-center align-start">
        <div class="d-flex flex-column justify-center align-center mx-6">
          <div dir="ltr" style=" height: 100px" class="d-flex justify-center align-center text-center">
            <h1
                style="color: #f2c303" class="font-weight-bold company-title">{{item.fields[0].value}}</h1>

          </div>
          <h5 class="font-weight-bold">{{ $t(item.title) }}</h5>
          <h6 v-html="item.details"></h6>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: 'CompanyHint',

  data() {
    return {
      hintList: [
        {

          // 'title': 'https://see.fontimg.com/api/renderfont4/2OvJ8/eyJyIjoiZnMiLCJoIjoxMzAsInciOjIwMDAsImZzIjo2NSwiZmdjIjoiI0Y3Q0YwQyIsImJnYyI6IiNGRkZGRkYiLCJ0IjoxfQ/KzU4/bronson.png',
          'title': '+2000',
          'subtitle': 'companyHintList[3].subtitle',
          // 'subtitle': 'کشور در دنیا در لیست صادرات',
          'content': 'companyHintList[3].content',
        },


        {

          // 'title': 'https://see.fontimg.com/api/renderfont4/2OvJ8/eyJyIjoiZnMiLCJoIjoxMzAsInciOjIwMDAsImZzIjo2NSwiZmdjIjoiI0Y3Q0YwQyIsImJnYyI6IiNGRkZGRkYiLCJ0IjoxfQ/KzEwMA/bronson.png',
          'title': '+100',
          'subtitle': 'companyHintList[1].subtitle',
          // 'subtitle': 'محصول منحصربه فرد',
          'content': 'companyHintList[1].content',
        },
        {

          // 'title': 'https://see.fontimg.com/api/renderfont4/2OvJ8/eyJyIjoiZnMiLCJoIjoxMzAsInciOjIwMDAsImZzIjo2NSwiZmdjIjoiI0Y3Q0YwQyIsImJnYyI6IiNGRkZGRkYiLCJ0IjoxfQ/KzIwMDA/bronson.png',

          'title': '+58',
          'subtitle': 'companyHintList[2].subtitle',
          // 'subtitle': 'سرمایه خلاق انسانی',
          'content': 'companyHintList[2].content',
        },
        {

          // 'title': 'https://see.fontimg.com/api/renderfont4/2OvJ8/eyJyIjoiZnMiLCJoIjoxMzAsInciOjIwMDAsImZzIjo2NSwiZmdjIjoiI0Y3Q0YwQyIsImJnYyI6IiNGRkZGRkYiLCJ0IjoxfQ/MQ/bronson.png',
          'title': '1',
          // 'subtitle': 'تیم واحد با انگیزه',
          'subtitle': 'companyHintList[0].subtitle',
          'content': 'companyHintList[0].content',
        },

      ]
    }
  },
  computed: {
    ...mapState({
      why: state => state.homeManagement.why,
    })
  }
}
</script>
<style scoped>

.item-title {
  color: #f3c303;
  font-size: 64px;
}
</style>